/* eslint-disable max-lines */
import { EcsProjectTeamName } from '../types';

export enum Experiment {
  QuickNavManageMyThings = 'QuickNavManageMyThings',
  MyGroupsAdminOfFilter = 'MyGroupsAdminOfFilter',
  AnalyticsEventsStrictSchema = 'AnalyticsEventsStrictSchema',
  AnalyticsDiscoveryBubble = 'AnalyticsDiscoveryBubble',
  AnalyticsSummaryCardV2 = 'AnalyticsSummaryCardV2',
  AnswersAdminAIFeaturesToggle = 'AnswersAdminAIFeaturesToggle',
  AnswersAISuggestedTopics = 'AnswersAISuggestedTopics',
  AnswerCommunityClientSupportsQuestionTitle = 'AnswerCommunityClientSupportsQuestionTitle',
  AnswersCommunityEnablement = 'AnswersCommunityEnablement',
  AnswerCommunitySearchUX = 'AnswerCommunitySearchUX',
  AnswersCommunityQuestionPublisherExperience = 'AnswersCommunityQuestionPublisherExperience',
  AnswersDismissTopicSuggestion = 'AnswersDismissTopicSuggestion',
  AnswersInlineExpansion = 'AnswersInlineExpansion',
  AnswersInVivaGA = 'AnswersInVivaGA',
  AnswersLikeReaction = 'AnswersLikeReaction',
  AnswersTopicBrowseImprovements = 'AnswersTopicBrowseImprovements',
  AnswersTopicManagementPainPoints = 'AnswersTopicManagementPainPoints',
  AnswersTopicPickerAlignment = 'AnswersTopicPickerAlignment',
  AnswersOnboarding = 'AnswersOnboarding',
  AnswerUpvoteRedesign = 'AnswerUpvoteRedesign',
  AnswersOnlyMode = 'AnswersOnlyMode',
  AnswersPostGAExperience = 'AnswersPostGAExperience',
  VivaEngageAmaSummary = 'VivaEngageAmaSummary',
  AtMentionCustomName = 'AtMentionCustomName',
  AutoSuggestionCampaignHashtag = 'AutoSuggestionCampaignHashtag',
  BackendGraphqlApiVnextEndpoint = 'BackendGraphqlApiVnextEndpoint',
  BackendLiveEventFeedCaching = 'BackendLiveEventFeedCaching',
  BackendLiveEventFeedCachingByTenant = 'BackendLiveEventFeedCachingByTenant',
  BackendOcularCosmos = 'BackendOcularCosmos',
  BellPageSize = 'BellPageSize',
  BespokeCommunityCreateEdit = 'BespokeCommunityCreateEdit',
  BookmarkThread = 'BookmarkThread',
  Campaigns = 'Campaigns',
  CampaignsHub = 'CampaignsHub',
  CampaignsCoOrganizers = 'CampaignsCoOrganizers',
  CampaignsExecutiveSponsorRefinement = 'CampaignsExecutiveSponsorRefinement',
  CampaignsExecutiveSponsorship = 'CampaignsExecutiveSponsorship',
  CampaignSashAvatar = 'CampaignSashAvatar',
  CampaignSearch = 'CampaignSearch',
  CampaignsKillSwitchUI = 'CampaignsKillSwitchUI',
  CampaignAnalyticsForExecutiveSponsorsAndOrganizers = 'CampaignAnalyticsForExecutiveSponsorsAndOrganizers',
  CampaignPrivateMessage = 'CampaignPrivateMessage',
  ClearPublisher = 'ClearPublisher',
  CommunityAma = 'CommunityAma',
  CommunityBadgeAdmin = 'CommunityBadgeAdmin',
  CommunityCampaigns = 'CommunityCampaigns',
  CommunityCoachTips = 'CommunityCoachTips',
  CommunityFeatureConversation = 'CommunityFeatureConversation',
  CommunityLiveEventsBanner = 'CommunityLiveEventsBanner',
  CommunityManagerSubscriptionTip = 'CommunityManagerSubscriptionTip',
  CommunityQuestionThreadUpdate = 'CommunityQuestionThreadUpdate',
  CommunitySetupTeachingBubbles = 'CommunitySetupTeachingBubbles',
  CommunitySubscriptionBubbleOnly = 'CommunitySubscriptionBubbleOnly',
  CompanyLogoInLCHeader = 'CompanyLogoInLCHeader',
  CondensedCardHomeFeed = 'CondensedCardHomeFeed',
  ConversationsVnext = 'ConversationsVnext',
  ConversationInsightsV2 = 'ConversationInsightsV2',
  CSVUploadGroupMembers = 'CSVUploadGroupMembers',
  LogProtobufEvents = 'LogProtobufEvents',
  DiscoverCommunitiesV2 = 'DiscoverCommunitiesV2',
  DiscoverOfficialCommunities = 'DiscoverOfficialCommunities',
  DivisionalBespokeCommunity = 'DivisionalBespokeCommunity',
  DraftAnnouncement = 'DraftAnnouncement',
  DraftPostCommunity = 'DraftPostCommunity',
  DomainMigration = 'DomainMigration',
  DraftPostStoryline = 'DraftPostStoryline',
  DraftSorting = 'DraftSorting',
  ScheduledPosts = 'ScheduledPosts',
  DwellTimeReporting = 'DwellTimeReporting',
  EmbedSupportForNetworkContext = 'EmbedSupportForNetworkContext',
  EmbedMsal = 'EmbedMsal',
  EnhancedDigestDiscoveryDesign = 'EnhancedDigestDiscoveryDesign',
  ExpandedReactionsEnabled = 'ExpandedReactionsEnabled',
  ExternalNetworksInGlammer = 'ExternalNetworksInGlammer',
  FAQIfy = 'FAQIfy',
  FavoritesDragDropReorder = 'FavoritesDragDropReorder',
  TopicBrowsePageFilters = 'TopicBrowsePageFilters',
  TopicSummaryCardIndicators = 'TopicSummaryCardIndicators',
  FollowButtonHomeFeedThreadWithGreyColor = 'FollowButtonHomeFeedThreadWithGreyColor',
  GroupHoverCardV2 = 'GroupHoverCardV2',
  GroupRecommendedFeed = 'GroupRecommendedFeed',
  GroupsFromGrouper = 'GroupsFromGrouper',
  HomeFollowingFeed = 'HomeFollowingFeed',
  HomeSidebarRelayOverhaul = 'HomeSidebarRelayOverhaul',
  InFeedUserSuggestions = 'InFeedUserSuggestions',
  InformationBarriersPhase0 = 'InformationBarriersPhase0',
  LeaderAudienceFeed = 'LeaderAudienceFeed',
  LeadershipManagement = 'LeadershipManagement',
  LeadersAudienceMS365Groups = 'LeadersAudienceMS365Groups',
  LeadershipLiveEventsBanner = 'LeadershipLiveEventsBanner',
  LeadersMultipleAudiences = 'LeadersMultipleAudiences',
  LeaderGroupsAddAsync = 'LeaderGroupsAddAsync',
  LeaderIdentificationFRE = 'LeaderIdentificationFRE',
  LeaderIDSmartEntryPoints = 'LeaderIDSmartEntryPoints',
  LightboxFollowUsers = 'LightboxFollowUsers',
  LongFormContentArticlePublisher = 'LongFormContentArticlePublisher',
  LongFormContentArticleView = 'LongFormContentArticleView',
  MicrosoftDesignerApp = 'MicrosoftDesignerApp',
  MTOAdminToggle = 'MTOAdminToggle',
  MTOLeader = 'MTOLeader',
  MTOStoryline = 'MTOStoryline',
  MTOBadge = 'MTOBadge',
  MTOBlendedInbox = 'MTOBlendedInbox',
  MTOBlendedLeaderCornerFeed = 'MTOBlendedLeaderCornerFeed',
  MTOCommunity = 'MTOCommunity',
  MTOGraphVNextResolvers = 'MTOGraphVNextResolvers',
  MultiTenantOrganization = `MultiTenantOrganization`,
  MobileCrossSellThreadViewV2 = 'MobileCrossSellThreadViewV2',
  NavPhase1 = 'NavPhase1',
  OWAFollowThreadStarter = 'OWAFollowThreadStarter',
  OWALeadershipBanner = 'OWALeadershipBanner',
  OWAStorylinesDigestFollowSenderButton = 'OWAStorylinesDigestFollowSenderButton',
  OdspFilePickerType = 'OdspFilePickerType',
  OfficeTopics = 'OfficeTopics',
  OneCameraV3 = 'OneCameraV3',
  OnePlayerNative = 'OnePlayerNative',
  OutlookAnswersDigestBanner = 'OutlookAnswersDigestBanner',
  OutlookLikeAnimation = 'OutlookLikeAnimation',
  OutlookNetworkLogo = 'OutlookNetworkLogo',
  OverrideAndDisableStorylineAnnouncements = 'OverrideAndDisableStorylineAnnouncements',
  PageThreadHomeFeed = 'PageThreadHomeFeed',
  PeopleSuggestion3SV3 = 'PeopleSuggestion3SV3',
  PinnedFiles = 'PinnedFiles',
  POBODrafts = 'POBODrafts',
  PraisePollTypeWrapperRefresh = 'PraisePollTypeWrapperRefresh',
  PostTypeWrapperRefresh = 'PostTypeWrapperRefresh',
  PrefilledDefaultAudience = 'PrefilledDefaultAudience',
  PreloadFeedAfterUserData = 'PreloadFeedAfterUserData',
  PublisherAbandonmentOCVSurvey = 'PublisherAbandonmentOCVSurvey',
  PublisherSuggestedTopics = 'PublisherSuggestedTopics',
  RemoveRedundantReplyRealtimePills = 'RemoveRedundantReplyRealtimePills',
  RemoveTopicsSDKDependencyForVivaTopicsInFeeds = 'RemoveTopicsSDKDependencyForVivaTopicsInFeeds',
  ReplyFlexRefactor = 'ReplyFlexRefactor',
  RestrictPostingAnyGroupRollout = 'RestrictPostingAnyGroupRollout',
  SearchDiscoverabilityFRE = 'SearchDiscoverabilityFRE',
  SearchPageAccess = 'SearchPageAccess',
  ServerSharePointWebLinks = 'ServerSharePointWebLinks',
  ShareAMAPoboToStoryline = 'ShareAMAPoboToStoryline',
  SharePointVideoLinkPreviews = 'SharePointVideoLinkPreviews',
  ShowUserCoverImage = 'ShowUserCoverImage',
  SmallFileUpload = 'SmallFileUpload',
  SplitDataAndPresentationComponents = 'SplitDataAndPresentationComponents',
  Stories = 'Stories',
  StoriesNotificationImmersiveView = 'StoriesNotificationImmersiveView',
  StoriesPostOnBehalfOfEnabled = 'StoriesPostOnBehalfOfEnabled',
  StoriesV2Cards = 'StoriesV2Cards',
  StorylineAdminGeneralAvailableEnabled = 'StorylineAdminGeneralAvailableEnabled',
  StorylineAnnouncement = 'StorylineAnnouncement',
  StorylineAnnouncementAudienceChannelsConfigEnabled = 'StorylineAnnouncementAudienceChannelsConfigEnabled',
  StorylineAnnouncementNotificationUrgency = 'StorylineAnnouncementNotificationUrgency',
  StorylineAnnouncementTeachingBubbleAndDisableInfobar = 'StorylineAnnouncementTeachingBubbleAndDisableInfobar',
  StorylineAnnouncementTeamsEmailChannelsEnabled = 'StorylineAnnouncementTeamsEmailChannelsEnabled',
  StorylineAsDefaultOnHomePublisher = 'StorylineAsDefaultOnHomePublisher',
  StorylineAudienceAnnouncement = 'StorylineAudienceAnnouncement',
  StorylineBootstrapNetworkCall = 'StorylineBootstrapNetworkCall',
  StorylineDefaultHomeFeedPublisherShortv2 = 'StorylineDefaultHomeFeedPublisherShortv2',
  StorylineDefaultHomeFeedPublisherLongv2 = 'StorylineDefaultHomeFeedPublisherLongv2',
  StorylineDirectAndDigestRebrand = 'StorylineDirectAndDigestRebrand',
  StorylineFeatureConversation = 'StorylineFeatureConversation',
  StorylineFollowBack = 'StorylineFollowBack',
  StorylineFREVivaEngage = 'StorylineFREVivaEngage',
  StorylineMediaPost = 'StorylineMediaPost',
  StorylinePerUserControl = 'StorylinePerUserControl',
  StorylinePostOnBehalfOfFiles = 'StorylinePostOnBehalfOfFiles',
  StorylinePremiumPreviewEnabled = 'StorylinePremiumPreviewEnabled',
  StorylinePublisherSettingsNetworkCall = 'StorylinePublisherSettingsNetworkCall',
  StorylinePublisherCoachingTips = 'StorylinePublisherCoachingTips',
  StorylinePublisherTipsLongV3 = 'StorylinePublisherTipsLongV3',
  StorylinePublisherTipsShortV3 = 'StorylinePublisherTipsShortV3',
  StorylineThreadCoachingTips = 'StorylineThreadCoachingTips',
  StorylineThreadTipsLongV3 = 'StorylineThreadTipsLongV3',
  StorylineThreadTipsShortV3 = 'StorylineThreadTipsShortV3',
  StorylineTrendingFollowButton = 'StorylineTrendingFollowButton',
  StreamieCosmosMigrationClient = 'StreamieCosmosMigrationClient',
  SuggestedTopicsAnswers = 'SuggestedTopicsAnswers',
  SuggestedTopicsEngageRightRail = 'SuggestedTopicsEngageRightRail',
  SuggestedTopicsOnEmptyFollowedTopicsPage = 'SuggestedTopicsOnEmptyFollowedTopicsPage',
  TargetedCampaigns = 'TargetedCampaigns',
  TeamsBackButton = 'TeamsBackButton',
  TeamsMeetingAccess = 'TeamsMeetingAccess',
  TeamsMeetingFeedFilterOptions = 'TeamsMeetingFeedFilterOptions',
  TeamsMeetingFeedReloadOnRealtimePillClick = 'TeamsMeetingFeedReloadOnRealtimePillClick',
  TeamsMeetingMaskIdentitiesBanner = 'TeamsMeetingMaskIdentitiesBanner',
  TeamsQnAMessageReactions = 'TeamsQnAMessageReactions',
  TeamsQnAFeedReset = 'TeamsQnAFeedReset',
  TeamsQnANotificationsDeepLinking = 'TeamsQnANotificationsDeepLinking',
  TeamsQnARemoveBestAnswer = 'TeamsQnARemoveBestAnswer',
  TeamsQnAThreadUpvote = 'TeamsQnAThreadUpvote',
  TeamsQnAVivaEngageAmaIntegration = 'TeamsQnAVivaEngageAmaIntegration',
  TeamsSearch = 'TeamsSearch',
  TeamsSupportFullWidthLayout = 'TeamsSupportFullWidthLayout',
  TranslateContentState = 'TranslateContentState',
  UnifiedTopicsFeed = 'UnifiedTopicsFeed',
  UserGroupsFromGrouper = 'UserGroupsFromGrouper',
  UserInsights = 'UserInsights',
  UserTags = 'UserTags',
  UserStoryline = 'UserStoryline',
  VivaEngageAmaAdoption = 'VivaEngageAmaAdoption',
  VivaEngageAmaCalendarInvite = 'VivaEngageAmaCalendarInvite',
  VivaEngageAmaCreationV2 = 'VivaEngageAmaCreationV2',
  VivaEngageAmaCoorganizers = 'VivaEngageAmaCoorganizers',
  VivaEngageAmaCreationInHomeRightRail = 'VivaEngageAmaCreationInHomeRightRail',
  VivaEngageAmaCreationInHomeRightRailV2 = 'VivaEngageAmaCreationInHomeRightRailV2',
  VivaEngageAmaNewQuestionNotificationEnabled = 'VivaEngageAmaNewQuestionNotificationEnabled',
  VivaEngageAmaCalendarInvitationToggle = 'VivaEngageAmaCalendarInvitationToggle',
  VivaEngageAmaPrivate = 'VivaEngageAmaPrivate',
  VivaEngageAmaFeedImprovements = 'VivaEngageAmaFeedImprovements',
  BackButton = 'BackButton',
  VivaEngageCoverImage = 'VivaEngageCoverImage',
  VivaEngageDeepLinkFromOWA = 'VivaEngageDeepLinkFromOWA',
  VivaEngageRightUXChangeV2 = 'VivaEngageRightUXChangeV2',
  VivaEngagePremium = 'VivaEngagePremium',
  VivaEngageQnAFastFollow = 'VivaEngageQnAFastFollow',
  VivaEngageCollapsiblePanelRecommendations = 'VivaEngageCollapsiblePanelRecommendations',
  VivaEngageCopilotInlineEditor = 'VivaEngageCopilotInlineEditor',
  VivaEngageCopilotMVP = 'VivaEngageCopilotMVP',
  VivaEngageCopilotBE = 'VivaEngageCopilotBE',
  VivaEngageLC = 'VivaEngageLC',
  VivaEngageTopicPickerAutoLoad = 'VivaEngageTopicPickerAutoLoad',
  VivaEngageTopicPickerTopicTypes = 'VivaEngageTopicPickerTopicTypes',
  VivaEngageTopicPickerTrendingTopics = 'VivaEngageTopicPickerTrendingTopics',
  VivaInsightsAudienceThemeCard = 'VivaInsightsAudienceThemeCard',
  VivaInsightsNetwork = 'VivaInsightsNetwork',
  VivaEngageAdminBanner = 'VivaEngageAdminBanner',
  VivaEngageRebranding = 'VivaEngageRebranding',
  VivaEngageRebrandingBanner = 'VivaEngageRebrandingBanner',
  VivaEngageRebrandingAdminBanner = 'VivaEngageRebrandingAdminBanner',
  VivaEngageTeamsLiveEventMobile = 'VivaEngageTeamsLiveEventMobile',
  VivaLeadershipChronoFeed = 'VivaLeadershipChronoFeed',
  VivaLeadershipCuratedFeed = 'VivaLeadershipCuratedFeed',
  VivaTopicsFRE = 'VivaTopicsFRE',
  WebRecorderMediaAttachmentInPublisher = 'WebRecorderMediaAttachmentInPublisher',
  YammerFeedbackSystem = 'YammerFeedbackSystem',
  NoWFMessageBodyInGroupMessageCreationResponse = 'NoWFMessageBodyInGroupMessageCreationResponse',
  MinimalWFPayloadOnReplyPosting = 'MinimalWFPayloadOnReplyPosting',
  HomeFeedAudienceAnalyticsSummaryCard = 'HomeFeedAudienceAnalyticsSummaryCard',
  HydrantFeedThreadCaching = 'HydrantFeedThreadCaching',
  HydrantHomeCaching = 'HydrantHomeCaching',
  HydrantThreadCaching = 'HydrantThreadCaching',
  OptimizedReactionsFetching = 'OptimizedReactionsFetching',

  // Existing experiments that incorrectly have 'Enabled' as part of their name.
  // Do not do this - 'enabled' should be the state of an experiment, not part of the name.
  // The name should instead focus on describing the feature/functionality affected.
  // Since these are already running and in use, we can't rename them, so just have
  // to let them run their course.
  CortexTopicCardsEnabled = 'CortexTopicCardsEnabled',
  LiveEventSortingChangeEnabled = 'LiveEventSortingChangeEnabled',
  ModulatorGroupSuggestionsEnabled = 'ModulatorGroupSuggestionsEnabled',

  // Experiments used for testing the experiment infrastructure - grouping
  // these separately from the regular feature experiments above. Regular
  // experiments should not have the name 'experiment' in them.
  ClientForwardExperimentForTesting1 = 'ClientForwardExperimentForTesting1',
  ClientForwardExperimentForTesting2 = 'ClientForwardExperimentForTesting2',
  CrossPlatformExperimentForTesting1 = 'CrossPlatformExperimentForTesting1',
  CrossPlatformExperimentForTesting2 = 'CrossPlatformExperimentForTesting2',
  ExperimentForTesting1 = 'ExperimentForTesting1',
  ExperimentForTesting2 = 'ExperimentForTesting2',
}

export type ExperimentTreatmentValue = string | boolean | number;

export interface ExperimentConfig {
  readonly id: string | undefined;
  readonly projectTeam: EcsProjectTeamName;
  readonly treatments: ExperimentTreatmentValue[];
  readonly defaultTreatment: ExperimentTreatmentValue;
}

export const experimentConfigs: ExperimentConfigs = {
  QuickNavManageMyThings: {
    id: '6a005258-30ee-443e-9b6e-ff1024e2b8c0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MyGroupsAdminOfFilter: {
    id: 'b1be92fd-10e9-404b-9ea0-9c987e54a8eb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnalyticsEventsStrictSchema: {
    id: '522ba782-172c-4a40-b569-6048a16bd73b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnalyticsDiscoveryBubble: {
    id: 'b8a544ef-ad31-414a-8ae0-03b15c392aab',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnalyticsSummaryCardV2: {
    id: '1e64204f-3a0e-446d-9fb2-c71e71d358d7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersAdminAIFeaturesToggle: {
    id: '0a688e8a-29a2-40f5-8883-bea082057a03',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersAISuggestedTopics: {
    id: 'e0307cc4-554d-431e-9139-a465368678c0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswerCommunityClientSupportsQuestionTitle: {
    id: '1d8019df-3772-493c-b09f-51026014580a',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersCommunityEnablement: {
    id: 'f02d5ba5-ec0e-4346-981d-a5fdc9aa30d7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, 'create_enabled', 'edit_and_create_enabled'],
    defaultTreatment: false,
  },
  AnswerCommunitySearchUX: {
    id: 'a5766fee-9478-488b-9fc0-64d1ad72c290',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersCommunityQuestionPublisherExperience: {
    id: '19794466-f49a-4d4e-86a9-d9404d95d89e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersDismissTopicSuggestion: {
    id: '53cce6a8-38cc-41d5-8661-007a1e6b5073',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersInlineExpansion: {
    id: '35421ec3-e148-43ce-a395-809d70b95697',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersInVivaGA: {
    id: '380a21a6-bc1e-4619-aa37-f11e947f9844',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersLikeReaction: {
    id: 'baee8bb6-d106-4bc2-b185-7f22b0543776',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersOnboarding: {
    id: '61d43214-e71d-44e1-b2a9-285a3c1ac7f0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersOnlyMode: {
    id: 'adfa8eca-2626-43df-9693-da8f9ba34bd7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersPostGAExperience: {
    id: 'b2b9090e-7752-4050-bf20-831f2c940ea9',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersTopicBrowseImprovements: {
    id: 'd4bab3dc-e76a-475a-82ed-f1ac66b01d87',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersTopicManagementPainPoints: {
    id: '48bab08d-6dd1-4d0d-ad2a-5fbe1907caea',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersTopicPickerAlignment: {
    id: 'f9d44728-a090-4628-ad56-dba52c558975',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswerUpvoteRedesign: {
    id: '4f9555aa-a589-487f-8b8b-a8a43fa3b9ab',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaSummary: {
    id: '71e1ce92-0426-4e43-8935-ca7d62a73ccc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AtMentionCustomName: {
    id: '0f7581eb-ad8e-4acc-80fa-75214dd00bed',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AutoSuggestionCampaignHashtag: {
    id: 'acc4854f-ed9d-4082-8f56-5f2bba1d2bed',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphqlApiVnextEndpoint: {
    id: 'fd389c01-9fdd-440d-af71-41aab31f2a57',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    defaultTreatment: 0,
  },
  BackendLiveEventFeedCaching: {
    id: '298a9ad9-4a09-4bc9-b03c-57409c423b7e',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendLiveEventFeedCachingByTenant: {
    id: 'cf0d025e-c359-4988-8ab4-abed3a5f7e77',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendOcularCosmos: {
    id: '6efb151f-2e3b-466f-9fac-d14928e0d815',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BellPageSize: {
    id: '5d034307-8927-41cc-bdc1-2b9b000bc466',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BespokeCommunityCreateEdit: {
    id: '63d38f2f-36df-4d03-b8ed-fa4f7e07b48f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BookmarkThread: {
    id: '73b842f4-791f-4157-a5b2-76917957057f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  Campaigns: {
    id: '64ddebd5-e905-48bc-bd39-38f059e55dfc',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsHub: {
    id: 'aefbd4b4-7240-4368-a057-35889afef9d3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsCoOrganizers: {
    id: 'c10ce8d9-b5ee-49cb-b815-544393f57c5e',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsExecutiveSponsorship: {
    id: '671d7ef6-08c8-4643-84c6-be6fe85d3df3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsExecutiveSponsorRefinement: {
    id: 'e346f173-4cc4-4dc4-b786-ea71c72f0c90',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignSashAvatar: {
    id: '16cd896a-947c-4767-ad07-d12496b328ad',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignSearch: {
    id: '07da9e7a-4510-408e-a5a4-00f7ce4e0ab5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsKillSwitchUI: {
    id: '05dd7188-d9ef-4191-8f31-961e23a3cf8c',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignPrivateMessage: {
    id: '908d243c-add7-4cae-b2f2-dae99cc15de3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignAnalyticsForExecutiveSponsorsAndOrganizers: {
    id: 'cd6a1b1a-e71b-4da9-82e4-f0c1a6858324',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ClearPublisher: {
    id: '07f24914-f032-4e84-bed0-69e292e0e81d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityAma: {
    id: '7a722cf9-e0e6-4acd-867f-e6557b4a7568',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityBadgeAdmin: {
    id: 'ace0c8c8-713f-433d-9807-2617506e7cbb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityCampaigns: {
    id: '4f8ed957-4e32-4dcd-be65-39c5361403e6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityCoachTips: {
    id: '45107b86-6a6f-4842-bd70-e3b9469361e6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityFeatureConversation: {
    id: '40ad4c65-5ac7-4f59-bf4f-7b4fde1f1883',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLiveEventsBanner: {
    id: 'e6c21c31-b85a-4710-9452-88be53ab9ca3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityManagerSubscriptionTip: {
    id: '44568163-115a-4170-b9c8-0314dab7745d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityQuestionThreadUpdate: {
    id: '5618bb4b-b608-4e04-8e91-e8e0eb9a8579',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySetupTeachingBubbles: {
    id: '9665f8af-afb7-4f17-83d6-dcaa4e7ea275',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySubscriptionBubbleOnly: {
    id: '62b198ee-a1ea-4235-af37-36e43c16942c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompanyLogoInLCHeader: {
    id: 'ca32a32d-1b98-44ab-87fc-de35ef47838e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CortexTopicCardsEnabled: {
    id: 'ae26490b-84e4-4c54-b485-97dafc981ec2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CondensedCardHomeFeed: {
    id: 'ae3bdd49-bf98-4787-89f0-ed46515f343d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ConversationsVnext: {
    id: 'ed36d7ef-a8eb-4cc4-b7e5-e1ddda3cdc18',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ConversationInsightsV2: {
    id: '7dce6f42-fd1b-4acf-9454-57a44d9273ec',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CSVUploadGroupMembers: {
    id: 'c435b040-40d3-4e6d-98ec-321f6229e34d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ClientForwardExperimentForTesting1: {
    id: undefined,
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  ClientForwardExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CrossPlatformExperimentForTesting1: {
    id: undefined,
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  CrossPlatformExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DiscoverCommunitiesV2: {
    id: '39b449a2-1fd5-4599-89d0-e2a86a1a16a5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['disabled', 'enabled'],
    defaultTreatment: 'disabled',
  },
  DiscoverOfficialCommunities: {
    id: 'b1de80d6-8d37-4ac3-980e-22264edb9654',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DivisionalBespokeCommunity: {
    id: '6f9c3ced-854b-4bc2-9af3-7db4be804007',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DomainMigration: {
    id: 'a1ea1302-97a8-48ed-ba43-7ac8ba437e35',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftAnnouncement: {
    id: '55e2c97d-3cb2-46cf-bb89-77bbbcbde0ff',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftPostCommunity: {
    id: 'ac5794d4-f2a5-4b78-89e7-9c3be86554c1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftPostStoryline: {
    id: '5b7fdb04-9145-4a3f-adff-1a83940e6be9',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftSorting: {
    id: '98e0ca69-7b24-4ce1-a33b-705b2fd15cbd',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ScheduledPosts: {
    id: '0bb5c899-a202-4d3a-8817-4cd33d946e43',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DwellTimeReporting: {
    id: '6598b5fb-5c58-4dac-b3ef-f5935c74298c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  EmbedMsal: {
    id: '012d222c-422f-446b-8477-c5dcad4cc15a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EmbedSupportForNetworkContext: {
    id: '2cf796ba-c50e-4098-b278-e200b4bece9d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnhancedDigestDiscoveryDesign: {
    id: '281e84a8-537f-4440-93e2-9b7c91289a99',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'all_surfaces', 'list_view', 'reading_pane'],
    defaultTreatment: 'control',
  },
  ExpandedReactionsEnabled: {
    id: '7196531b-8e19-464d-a04b-ee2e0ea08e2b',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExperimentForTesting1: {
    id: 'fake-guid-for-testing',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 't1'],
    defaultTreatment: 'control',
  },
  ExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExternalNetworksInGlammer: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  FAQIfy: {
    id: '841a0b15-388f-4059-9b18-4065835cff5d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  FavoritesDragDropReorder: {
    id: '83593909-57d5-49e8-b3f4-eca2e2c142d2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TopicBrowsePageFilters: {
    id: 'b04d7997-f7c5-4c1d-80c4-e10ac8c7af7a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TopicSummaryCardIndicators: {
    id: 'aa670116-5858-42fc-b3c6-dbb949ea7fa0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  FollowButtonHomeFeedThreadWithGreyColor: {
    id: '440bb634-1b43-44c8-9251-e9d02a469570',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  HomeFeedAudienceAnalyticsSummaryCard: {
    id: '5533ddea-2384-411a-b4e3-4c632abf5325',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  GroupsFromGrouper: {
    id: '49b25bb2-375e-46ce-8624-6224d5254df0',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  HomeFollowingFeed: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  HomeSidebarRelayOverhaul: {
    id: '1dea87a5-c3fb-4233-9e5a-649c45a2cc4a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [true, false],
    defaultTreatment: false,
  },
  InFeedUserSuggestions: {
    id: 'edc8645c-a10d-4ab1-aab3-34842a682c5d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'rankie', 'enabled'],
    defaultTreatment: 'control',
  },
  InformationBarriersPhase0: {
    id: '43ad10c3-30df-40d6-8cb2-7a9bc0c1ea0c',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  GroupHoverCardV2: {
    id: 'e22b6ca1-ad23-4176-afbf-ab7b9365648e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  GroupRecommendedFeed: {
    id: '8fb58315-f5c5-4fad-8c7b-623faf57ff6e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeaderAudienceFeed: {
    id: '45242ffb-565d-45c3-9aec-cead8078233c',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeadershipManagement: {
    id: '0c10cfbf-0a5c-44b9-afcb-40ff9c94669f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersAudienceMS365Groups: {
    id: 'fc767b4c-89f0-46f4-8ff8-daacee9e02c3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadershipLiveEventsBanner: {
    id: '6e64a6f2-ea2e-46ac-b15e-ceb156efe4e8',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersMultipleAudiences: {
    id: '102f1ab4-350f-430a-b677-f9e03715eced',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderGroupsAddAsync: {
    id: 'c67be930-601d-40f2-a300-b3027ea21b10',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderIdentificationFRE: {
    id: '7fbec9fc-302d-4800-876e-77a6df7ac5d2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderIDSmartEntryPoints: {
    id: 'ba201a97-746e-4d4c-8038-51d472e20e19',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LightboxFollowUsers: {
    id: 'd34c34e0-815c-4133-a17d-fe181895cf4d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LiveEventSortingChangeEnabled: {
    id: '33d94caa-e259-4c4f-be93-656012fe9b84',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LogProtobufEvents: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LongFormContentArticlePublisher: {
    id: '202f8671-9322-4bef-9922-b1ab63deca87',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LongFormContentArticleView: {
    id: 'f247289d-02e7-4931-9e1b-af215bf3f798',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RestrictPostingAnyGroupRollout: {
    id: 'de3b6c60-f521-4e7d-b89a-2c8d19d81785',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MicrosoftDesignerApp: {
    id: '49497680-16e2-43f4-bc69-0363063618c2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModulatorGroupSuggestionsEnabled: {
    id: 'bfd3fd32-6e3c-41c0-a792-8962dab5d283',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOAdminToggle: {
    id: 'a466846a-de55-4370-ada6-6f172ac23126',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOLeader: {
    id: 'df92b4cc-fa07-4198-ac7a-4106215c0c2c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOStoryline: {
    id: '773bacc9-2f0d-41f8-ae8d-d8528c0ef1bc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBadge: {
    id: '1709ba31-c004-438a-bc2d-98172009fe26',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBlendedInbox: {
    id: '50746bf4-b609-43de-9287-c67c52b25d7d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBlendedLeaderCornerFeed: {
    id: '810cfb9b-6789-499c-a4c8-2ec2cd115b4b',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOCommunity: {
    id: 'e34e6b47-9c6f-4ce9-87c5-f171f05b1e9c',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOGraphVNextResolvers: {
    id: 'ddee0f75-88c7-4f47-93bd-d9d305dc8fd8',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MultiTenantOrganization: {
    id: 'eaef51f5-5324-4fff-a9be-189da3de3a89',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MobileCrossSellThreadViewV2: {
    id: '38b66b3c-4070-49d7-8503-67c0b615bb0f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'qrCode', 'banner', 'coachingTip'],
    defaultTreatment: 'control',
  },
  NavPhase1: {
    id: '0375019f-e3a8-475f-819e-0c3193c00087',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'pillars', 'pillars_header_menu', 'pillars_header_menu_search', 'pillars_header'],
    defaultTreatment: 'control',
  },
  OneCameraV3: {
    id: 'b4c0de9d-144f-4dd5-9357-f6453c73d48b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayerNative: {
    id: 'c014fb1e-2d91-47e7-9d63-005fa8fd0490',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAFollowThreadStarter: {
    id: '0c33cbf5-a90b-4064-a7c5-d6e354984aaf',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWALeadershipBanner: {
    id: 'e0432184-23c4-409a-a098-54797e862b92',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAStorylinesDigestFollowSenderButton: {
    id: '9729aeb6-144b-413a-a06b-9fe4024fcb34',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OdspFilePickerType: {
    id: 'a316df71-760f-47ec-97fd-84e11f14017c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'group', 'onedrive'],
    defaultTreatment: 'control',
  },
  OfficeTopics: {
    id: 'fbd301cf-0130-4803-a7ed-f083f9a9b91f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OutlookAnswersDigestBanner: {
    id: '43e9e2b7-a180-41a6-a9b7-2fbeb2b822be',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OutlookLikeAnimation: {
    id: 'ac20c409-bc99-47ea-9564-77a61f8fb791',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OutlookNetworkLogo: {
    id: '7acf6711-e9e0-4936-af55-0a5c264078e6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OverrideAndDisableStorylineAnnouncements: {
    id: 'eadeebf7-56b1-4d01-9b95-556c3f1b4f26',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PageThreadHomeFeed: {
    id: '297975e3-1a9f-4f4b-9248-019eaf25fac1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PeopleSuggestion3SV3: {
    id: '5d873e2e-b60c-43d5-801a-716cce0894bc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, 'enabled'],
    defaultTreatment: false,
  },
  PinnedFiles: {
    id: 'b2b7ae31-803f-42f8-833b-5d99489cc3a5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  POBODrafts: {
    id: '41e1a98c-4edd-4839-947d-ec8bbee3224b',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PraisePollTypeWrapperRefresh: {
    id: 'aaba31d6-0d1f-478b-848b-86a0c19538bc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PostTypeWrapperRefresh: {
    id: '1f87bc45-858b-4852-ad89-9540f53890f5',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrefilledDefaultAudience: {
    id: 'a7c7ce2f-c586-40c7-abae-8d2c916a3572',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PreloadFeedAfterUserData: {
    id: 'd23567c1-3f29-4cb1-a0ae-2c83f4d1b6b6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PublisherAbandonmentOCVSurvey: {
    id: '96eea534-dc14-4e29-a10b-cd4c3ace6545',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherSuggestedTopics: {
    id: 'df2bddf4-61dd-4bc5-a1c7-778939fe36ae',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RemoveRedundantReplyRealtimePills: {
    id: 'd8cda085-265c-49a7-8313-b17860b1fe22',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RemoveTopicsSDKDependencyForVivaTopicsInFeeds: {
    id: '4992995f-b0d5-4b77-997c-703e977eda4d',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ReplyFlexRefactor: {
    id: 'a4f460c9-cb68-41c7-b043-f1f745c3816e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchDiscoverabilityFRE: {
    id: '179aa02b-969b-4288-b812-d2998c9b74e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'treatmenta', 'treatmentb'],
    defaultTreatment: 'control',
  },
  SearchPageAccess: {
    id: 'fa5310b5-3f7c-42e9-8e65-be17f1b163b6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ShowUserCoverImage: {
    id: '1b55e8eb-36f3-4022-ac2c-2588d3869931',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SmallFileUpload: {
    id: '8c7e99ba-f485-46ea-9c15-963168beaf73',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SplitDataAndPresentationComponents: {
    id: '7bab3ae5-1adc-46f4-ba94-d301aa631953',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  Stories: {
    id: '06ca9171-c49a-4437-87ff-db71db80eca0',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesNotificationImmersiveView: {
    id: '9ca54bd7-ce52-490e-976f-5feef3a8e6a3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesPostOnBehalfOfEnabled: {
    id: '466fb696-01ba-46f9-b815-5841afd683d5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesV2Cards: {
    id: '8ce624f9-6d36-46be-a1b8-66a4e9200e0c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAdminGeneralAvailableEnabled: {
    id: '7a2df625-43b9-4acd-a37b-264eb742a9a1',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncement: {
    id: '63dcaeb4-9f44-4b60-862c-d66b6b91138f',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementAudienceChannelsConfigEnabled: {
    id: '815edf06-def6-4e9e-93f5-dee926e9c4ad',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementNotificationUrgency: {
    id: '4915afb3-27fd-4dac-8a02-dd6cc20310c7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAnnouncementTeachingBubbleAndDisableInfobar: {
    id: '8714e391-0b32-4202-9c11-5da24443b1c5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementTeamsEmailChannelsEnabled: {
    id: 'bda9c5a1-3e58-40ce-8525-04605ef7fb28',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAudienceAnnouncement: {
    id: 'c1d26cfd-f6e1-4322-9831-8297fc3fd538',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAsDefaultOnHomePublisher: {
    id: '607d8f62-67cc-46dd-8ab9-05dfe7093edf',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineBootstrapNetworkCall: {
    id: '6e42a50a-6e69-4530-95db-d031602db681',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherShortv2: {
    id: 'ffde70ab-2ccf-4025-9cb2-6b386c65f7a1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherLongv2: {
    id: 'cd8b5099-2742-4e28-bf15-e2170c394bd5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDirectAndDigestRebrand: {
    id: 'a9c87cbf-fbab-45b9-b081-0d60f239ce37',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineFeatureConversation: {
    id: 'd7bd2914-15a3-4557-a105-46f340f6ee97',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFollowBack: {
    id: 'e134b15f-4875-4f81-b180-a2777912074d',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFREVivaEngage: {
    id: 'af384543-6d30-4364-86ed-a119538de985',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineMediaPost: {
    id: '289e4542-d271-4c2d-82bd-58aa4c43cbf0',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePerUserControl: {
    id: '974480fc-4e4d-472a-8785-aead29cab958',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePostOnBehalfOfFiles: {
    id: '59406740-42da-404e-a41d-23324e366f0d',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePremiumPreviewEnabled: {
    id: 'f1d5bdbe-186d-440e-b4b6-0ce444d1799a',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherSettingsNetworkCall: {
    id: '968afe62-d291-42c8-8816-9b5d99d86cfa',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherCoachingTips: {
    id: '31c06d83-f8eb-4423-a704-9294705c5ab5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsLongV3: {
    id: '6ccecbf9-797e-4289-b9ef-1976e6e78cd3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsShortV3: {
    id: 'aaaa837e-517c-491e-b691-512b2b14d6b3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadCoachingTips: {
    id: 'd02b84c7-32c3-42f4-8edc-a9116e7054cc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsLongV3: {
    id: '6980c260-9492-4754-a800-c0caf6bada91',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsShortV3: {
    id: '151b08a8-8224-4a4b-803a-d768bdfa2d72',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineTrendingFollowButton: {
    id: 'f56abf39-e462-46ce-ad76-ddd572a1e20c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StreamieCosmosMigrationClient: {
    id: '2a9dc0ad-e571-4bd0-9977-35d843b45367',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SuggestedTopicsAnswers: {
    id: '0695670d-e191-4bdc-9e21-b6869f82cc4e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SuggestedTopicsEngageRightRail: {
    id: '0695670d-e191-4bdc-9e21-b6869f82cc4e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SuggestedTopicsOnEmptyFollowedTopicsPage: {
    id: '1f1656fb-e503-4a30-9e4c-909000c87a87',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TargetedCampaigns: {
    id: '6dbe2dc5-816e-4b34-baaa-e980d0503981',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBackButton: {
    id: '78187586-38f7-4984-b4e4-b8b9ea9a06d5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingAccess: {
    id: 'a1e4ad9b-3252-476f-8d36-d1ab593eea1e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingFeedFilterOptions: {
    id: 'fbba4a58-1998-4230-9a99-238ab7f6f938',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingFeedReloadOnRealtimePillClick: {
    id: '8afff486-fb47-4c10-ac48-7aa598b378af',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingMaskIdentitiesBanner: {
    id: '4e3e9c95-61f3-4696-9261-2f133c295417',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAMessageReactions: {
    id: '5c5e3512-c64c-49c7-9e4c-80196146e719',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAFeedReset: {
    id: '843e64a0-d562-462b-bc22-14404b918cad',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnANotificationsDeepLinking: {
    id: 'f051bee8-8271-4a36-9d5c-cfba7c37ff9f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TeamsQnARemoveBestAnswer: {
    id: '79b20ced-9a70-4b86-bea5-3ad9b5828b0a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAThreadUpvote: {
    id: '579fb564-0151-42d3-9416-4f9e351770a1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAVivaEngageAmaIntegration: {
    id: 'ecaea425-6f6c-49c4-9dbe-a68dd083cdda',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsSearch: {
    id: '9cc341e5-b28d-41e1-ae51-a372bf3798f6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsSupportFullWidthLayout: {
    id: 'd3654b05-e089-49a4-a25d-a9c0a5feb2e1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TranslateContentState: {
    id: '80d74ee5-845f-4c40-83dc-075b3a86e18e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserGroupsFromGrouper: {
    id: 'e745b9c1-095b-45f6-a2aa-a4989bb2c0d8',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UserTags: {
    id: 'cc278c50-d599-4b2f-9a7d-33548c2cfd79',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserInsights: {
    id: '7d5f49c9-25c0-46fd-8679-83880a68708a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserStoryline: {
    id: 'ae197ce2-a0af-41e8-bd77-5d0ffca83ce1',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ServerSharePointWebLinks: {
    id: 'cb6da583-69f6-422d-ba1c-0d1bf9af85e8',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ShareAMAPoboToStoryline: {
    id: '6649bf4b-142b-4061-a46c-a1b2103d6551',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointVideoLinkPreviews: {
    id: '28323fd7-5caa-420d-998d-88f9224d9698',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UnifiedTopicsFeed: {
    id: '14e29a6a-f792-458d-8456-062f8374c65d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageAdminBanner: {
    id: 'f81f90cd-46c2-4caa-990b-f91f448ca776',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaAdoption: {
    id: 'e773c0b9-c753-4ffc-a542-d63aa84aadff',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCalendarInvite: {
    id: 'eea95241-fcdc-4158-b266-55429904071b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCreationV2: {
    id: '0fe5340a-6d16-4697-a22f-bc6848d1b4dc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCreationInHomeRightRail: {
    id: '118946ac-d982-45ca-8b90-e1bb48ff0184',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'above_suggested_cards', 'bottom_of_right_rail'],
    defaultTreatment: 'control',
  },
  VivaEngageAmaCreationInHomeRightRailV2: {
    id: 'f6ae8d08-de2d-4cbb-bd33-6f6a9514d041',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'above_suggested_cards', 'bottom_of_right_rail'],
    defaultTreatment: 'control',
  },
  VivaEngageAmaNewQuestionNotificationEnabled: {
    id: 'e9548f16-e005-439a-9c89-dc857f72293c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCalendarInvitationToggle: {
    id: '69701c3e-6979-4499-8b84-17f079056a15',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaFeedImprovements: {
    id: '8457875d-b8e7-4dbd-9eea-9e2d24b17b83',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCoorganizers: {
    id: '23c1381a-ec60-43d5-a84a-c2985936a829',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaPrivate: {
    id: '0c899ffc-7886-48fd-b1e5-989c91110ef4',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackButton: {
    id: 'c338cf06-3658-48a1-a9c9-264c2ba31e06',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCoverImage: {
    id: '52589660-bd2e-495b-8264-3729d18bbbb5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageDeepLinkFromOWA: {
    id: '2809a765-1843-4189-9460-cb296610a0f7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageRightUXChangeV2: {
    id: 'a5766fee-9478-488b-9fc0-64d1ad72c290',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'treatmenta', 'treatmentb', 'treatmentc', 'treatmentd'],
    defaultTreatment: 'control',
  },
  VivaEngagePremium: {
    id: '7967125b-c339-443b-927f-c7f0a908ae30',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageQnAFastFollow: {
    id: '9aff7a51-f6b5-4f4b-83d8-9bbf00d93b74',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCollapsiblePanelRecommendations: {
    id: '2cc0b58b-35a0-47d8-aee4-51c37f7aef0b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotBE: {
    id: '8d51b16b-0cf0-414e-b3d9-5ca3bb56b443',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageCopilotInlineEditor: {
    id: 'bb192c55-8559-4adf-8a06-8bacd67e9f22',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotMVP: {
    id: '6e02a4ce-c0e1-4c36-bcdb-9e21e57fd501',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageLC: {
    id: 'f01b8142-2f47-492c-a640-b3836b8b7afc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageTopicPickerAutoLoad: {
    id: 'c714281d-aa54-4607-8efa-dfa6fb7e4b5b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageTopicPickerTopicTypes: {
    id: '9a939091-f1c4-414a-ba81-310c679d8baa',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageTopicPickerTrendingTopics: {
    id: '333ea886-87a1-4436-bc0a-933ed394bbdc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsNetwork: {
    id: '67514bb4-5c15-420f-8303-d2f2500c4bde',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsAudienceThemeCard: {
    id: 'c2fb6d1b-27e3-4874-b037-1733e2af6173',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipChronoFeed: {
    id: '0bc20bf9-4197-40fe-b262-912c9bebf58b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipCuratedFeed: {
    id: '3f8817dc-c4c0-464c-a2f2-34b5d1b0fd81',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageRebranding: {
    id: 'f7a43a1b-dc64-4158-b3dd-5a46655944cd',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageRebrandingBanner: {
    id: '9cee3a74-b547-43a7-939d-a0aa9b5a9de7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageRebrandingAdminBanner: {
    id: 'd976eaa7-08d3-441b-9ee6-b48a05f4d6ed',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageTeamsLiveEventMobile: {
    id: '6f2f97ba-ec37-4508-8b12-fbbf3e648186',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaTopicsFRE: {
    id: '8248931d-3124-4aa8-863c-46b8a44fa60a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  WebRecorderMediaAttachmentInPublisher: {
    id: 'bf6acfd3-e7b4-4283-a076-963aeb073e2d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  YammerFeedbackSystem: {
    id: 'f70e29db-cc6e-4622-984f-004442019b12',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  NoWFMessageBodyInGroupMessageCreationResponse: {
    id: '9c4d957c-94b1-43d8-bcc6-84a14db0cde2',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MinimalWFPayloadOnReplyPosting: {
    id: '4def6d5d-ad49-4be4-8d63-dede011d672f',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  HydrantFeedThreadCaching: {
    id: 'bd124e45-6a93-4ead-af09-91df1123726d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  HydrantHomeCaching: {
    id: 'b754e406-d538-4581-966d-5d0a3db08c27',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  HydrantThreadCaching: {
    id: '1e3fe465-fd1b-4e82-a5d6-91da4e59361b',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OptimizedReactionsFetching: {
    id: '5fc95130-6444-4e47-92fc-f3ca5a16ac6f',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
};

export type ExperimentConfigs = Record<Experiment, ExperimentConfig>;

export type ExperimentTreatments = Record<Experiment, ExperimentTreatmentValue>;

export const defaultExperimentTreatments = (Object.keys(experimentConfigs) as Experiment[]).reduce(
  (acc: Record<Experiment, ExperimentTreatmentValue>, key: Experiment) => ({
    ...acc,
    [key]: experimentConfigs[key].defaultTreatment,
  }),
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  {} as Record<Experiment, ExperimentTreatmentValue>
);

export interface EcsExperiments {
  readonly treatments: ExperimentTreatments;
  readonly treatmentsFromService: Partial<ExperimentTreatments>;
  readonly treatmentOverrides: Partial<ExperimentTreatments>;
}
